<template>
  <div class="page-guarantee">
    <!-- 如何查询IMEI码 -->
    <ImeiLookupDialog :visible="queryimeiVisible" @dialog-cancel="queryimeiVisible = false" />

    <!-- 查询保修信息 -->
    <GuaranteeInfoDialog
      :visible="querywarrantyinforVisible"
      @dialog-cancel="querywarrantyinforVisible = false"
      :formData="formData"
    />

    <main>
      <div class="banner-contant">
        <div class="main-content">
          <div class="left">
            <h1 class="big-minder">保修期查询</h1>
          </div>
        </div>
      </div>
    </main>
    <section class="service-warranty">
      <div class="warranty-form">
        <div class="warranty-title">保修期查询</div>
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          @submit.native.prevent
          label-width="0"
          label-position="top"
        >
          <el-form-item prop="imeiOrSn">
            <el-input
              @keyup.enter.native="submitForm('ruleForm')"
              v-model="ruleForm.imeiOrSn"
              placeholder="请输入10-30位IMEI或SN码"
              aria-label="IMEI或SN码"
            ></el-input>
            <span class="queryIMEI" @click="queryimeiVisible = true">
              <span class="ruhe">如何查询IMEI/SN</span>
              <img src="imgs/queryiemi-icon.svg" class="query-icon" alt="" />
            </span>
          </el-form-item>
          <el-form-item prop="captcha" style="margin-bottom: 0">
            <el-input v-model="ruleForm.captcha" placeholder="请输入验证码" aria-label="验证码" maxlength="4"></el-input>
            <img class="captchapicture" alt="图形验证码，点击更换" @click="changeTime" :src="'/repair-api/captcha/getCaptcha?captchaId=' + ruleForm.captchaId">
          </el-form-item>
          <el-form-item class="bottom-btns">
            <el-button class="submit-btn" @click.native.prevent="submitForm('ruleForm')">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </section>
  </div>
</template>

<script>
import { PATTERN } from '../commons/utils/constants'
import GuaranteeInfoDialog from './components/GuaranteeInfoDialog.vue'
import ImeiLookupDialog from '../commons/components/ImeiLookupDialog.vue'

export default {
  data() {
    return {
      queryimeiVisible: false,
      querywarrantyinforVisible: false,
      formData: {
        isOverdue: "",
        model: "",
        IEMINumber: "",
        endTimeStr: "",
        isEstimated: ''
      },
      cationcode: "",
      ruleForm: {
        imeiOrSn: '',
        captcha: "",
        captchaId: Date.now() + ''
      },
      rules: {
        imeiOrSn: [
          { required: true, message: '请输入IMEI或SN号码', trigger: 'blur' },
          { pattern: /^.{10,30}$/, message: 'IMEI或SN号必须是10-30位', trigger: 'blur' }
          // { pattern: PATTERN.imei, message: 'IMEI号码不正确', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: PATTERN.captcha, message: '验证码不正确', trigger: 'blur' }
        ]
      },
    }
  },

  components: {
    ImeiLookupDialog,
    GuaranteeInfoDialog
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$request('post', '/repair-api/repair/repair-time-query-by-captcha', this.ruleForm).then(resp => {
            this.formData = resp.data
            this.formData.IEMINumber = this.ruleForm.imeiOrSn
            this.querywarrantyinforVisible = true
            this.changeTime()
          }).catch(err => {
            this.$message.error(err.msg)
            this.changeTime()
          })
        } else {
          return false;
        }
      });
    },
    changeTime(){
      this.ruleForm.captchaId = Date.now() + ''
    }
  },
}
</script>

<style lang="scss">
.page-guarantee {
  main {
    height: 29.270833vw;
    background: url(/imgs/service-warranty.png) no-repeat;
    background-size: cover;
  }

  .main-content {
    box-sizing: border-box;
    display: flex;
    width: 62.5vw;
    padding-top: 12.604167vw;
    margin: 0 auto;
  }
  .main-content .left {
    box-sizing: border-box;
  }

  .big-minder {
    width: 18.75vw;
    height: 4.6875vw;
    font-size: 3.75vw;
    font-family: OPPOSans-B, OPPOSans;
    font-weight: normal;
    color: #191919;
    line-height: 4.6875vw;
  }

  .service-warranty {
    width: 848px;
    padding: 120px 0;
    background-color: #fff;
    margin: 0 auto;

    .warranty-title {
      margin-bottom: 100px;
      height: 3.541667vw;
      font-size: 1.875vw;
      font-family: OPPOSans-B, OPPOSans;
      font-weight: normal;
      color: #191919;
      line-height: 2.916667vw;
      text-align: center;
    }

    .el-input {
      width: 705px;
      vertical-align: middle;
      .el-input__inner:focus{
        border-color: #CDD5D2
      }
    }
  }

  .queryIMEI {
    cursor: pointer;
    font-size: 0.833333vw;
    font-family: OPPOSans-R, OPPOSans;
    font-weight: normal;
    color: #31a9f8;
    line-height: 32px;
    display: inline-block;
    margin-left: 10px;
    box-sizing: border-box;
    text-align: left;
    vertical-align: middle;

    .ruhe {
      display: inline-block;
      vertical-align: middle;
    }

    .query-icon {
      width: 16px;
      margin-left: 4px;
      vertical-align: middle;
    }
  }

  .captchapicture {
    width: 120px;
    height: 64px;
    margin-left: 10px;
    background: #eaf9ed;
    vertical-align: bottom;
    text-align: center;
    cursor: pointer;
  }
  .bottom-btns {
    margin-top: 100px;
  }
  .submit-btn {
    width: 160px;
    margin: 0 auto;
    padding: 0;
    line-height: 48px;
    color: #fff;
    font-size: 20px;
    text-align: center;
    background: #45c98e;
    border-color: #45c98e;
    border-radius: 4px;
    display: block;
    &:hover{
     background: #2BAD73;
     border-color: #2BAD73;
    }
  }
}
</style>
